import React, {useState, useEffect} from 'react';
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {Table} from "react-bootstrap";
import Moment from "moment/moment";


const MonthlyInspections = () => {

    const [clientInfo, setClientInfo] = useState('')
    const [inspectionChartData, setInspectionChartData] = useState("");

    const { id } = useParams();

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const getSingleClient = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
            // const {data} = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });
        setClientInfo(data)
    }
    const getMonthlyInspectionsForChart = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/client_monthly_inspections/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/client_monthly_inspections/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        });

        setInspectionChartData(data)
    }

    useEffect(()=>{
        getSingleClient();
        getMonthlyInspectionsForChart();
    }, [])


    return (
        <div className={"banner_heading"}>
            {/*<Link */}
            {/*    style={{*/}
            {/*    display: 'flex',*/}
            {/*    alignItems: 'center',*/}
            {/*    justifyContent: 'center',*/}
            {/*    marginTop:'5px'*/}
            {/*}} */}
            {/*    className={'btn btn-outline-danger'} */}
            {/*    to={`/clients/${clientInfo.id}/add_monthly_inspection/`}*/}
            {/*>*/}
            {/*    Add Monthly Inspection*/}
            {/*</Link>*/}

            <br/>
            <h1>{clientInfo.work_site_address} || {clientInfo.project_ID}</h1>
            <h2>SYSTEM INSPECTION REPORT</h2>
            <br/>

            <div>
                {inspectionChartData
                ?
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Inspection Date</th>
                                <th>Inspection Type</th>
                                <th>System 1 Readings</th>
                                <th>System 2 Readings</th>
                                <th>Inspected By</th>
                                <th>Comments</th>
                                <th>Floor Plan</th>
                                <th>Update Inspection</th>
                            </tr>
                        </thead>
                        {inspectionChartData?.map((val, key) => {
                            return (
                                <tbody>
                                    <tr key={key}>
                                        <td>{Moment(val.inspection_date).format("[Inspected On:] MM/DD/YYYY")}</td>
                                        <td>{val.inspection_type}</td>
                                        <td>{val.system_1_readings}</td>
                                        <td>{val.system_2_readings}</td>
                                        <td>{val.inspected_by}</td>
                                        <td>{val.comments}</td>
                                        <td>{
                                            val.floor_plan ? (
                                                <a
                                                href={
                                                    `https://homesafetysolutions.pythonanywhere.com${val.floor_plan}`
                                                    // `http://127.0.0.1:8000${val.floor_plan}`
                                                }>
                                                <img
                                                    className={'floorPlanImage'}
                                                    src={`https://homesafetysolutions.pythonanywhere.com${val.floor_plan}`}
                                                    // src={`http://127.0.0.1:8000${val.floor_plan}`}
                                                     alt={'Floor Plan'}/>
                                                </a>
                                                )
                                                :
                                                ("No Floor Plan"
                                                )
                                        }</td>
                                        <td><Link className={'btn btn-primary'} to={`/monthly_inspection/update/${val.id}/`}>Update Inspection</Link></td>
                                    </tr>
                                </tbody>
                            )
                        })}
                    </Table>
                    :
                    ("Data has not yet been entered")
                }

            </div>

        </div>
    )
}

export default MonthlyInspections
